// =============================================================================
// slugify — PL diakrytyki → ASCII, lowercase, dashes
// =============================================================================
// Standardowa konwersja dla WordPress slugs i URL-safe identifiers.
// WP REST POST /wp/v2/categories oczekuje [a-z0-9-]+ w polu `slug`.
// =============================================================================

const PL_DIACRITICS: Record<string, string> = {
  "ą": "a", "ć": "c", "ę": "e", "ł": "l", "ń": "n",
  "ó": "o", "ś": "s", "ź": "z", "ż": "z",
  "Ą": "a", "Ć": "c", "Ę": "e", "Ł": "l", "Ń": "n",
  "Ó": "o", "Ś": "s", "Ź": "z", "Ż": "z",
};

/**
 * Converts string to WordPress-friendly slug.
 *
 * - PL diacritics → ASCII (ą→a, ł→l, ż→z, ...)
 * - Whitespace, special chars → "-"
 * - Collapse consecutive dashes
 * - Trim leading/trailing dashes
 * - Lowercase
 * - Max 50 chars (WP slug limit reasonable)
 *
 * @example
 *   slugify("Growth Hacking — Podstawy & Trendy 2026!")
 *   // → "growth-hacking-podstawy-trendy-2026"
 *
 *   slugify("Łódka żółta i ŻABA")
 *   // → "lodka-zolta-i-zaba"
 */
export function slugify(input: string, maxLength = 50): string {
  if (!input) return "";

  // 1) PL diacritics
  let s = input;
  for (const [from, to] of Object.entries(PL_DIACRITICS)) {
    s = s.split(from).join(to);
  }

  // 2) Lowercase
  s = s.toLowerCase();

  // 3) Replace non-alphanumeric (except dash) z dash
  s = s.replace(/[^a-z0-9]+/g, "-");

  // 4) Collapse consecutive dashes
  s = s.replace(/-+/g, "-");

  // 5) Trim leading/trailing dashes
  s = s.replace(/^-+|-+$/g, "");

  // 6) Max length
  if (s.length > maxLength) {
    s = s.slice(0, maxLength);
    // Avoid trailing dash from cut
    s = s.replace(/-+$/, "");
  }

  return s;
}
